import './HobbiesAndTravellersTypeCarousel.css';
import React, { useEffect, useRef, useState } from 'react';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import CarouselProvider from '../../../atoms/CarouselProvider/CarouselProvider';
import HobbiesAndTravellersTypeItem from './HobbiesAndTravellersTypeItem';
import { get } from '../../../../utils';
const HobbiesAndTravellersTypeCarousel = _ref => {
  let {
    cards,
    carouselView = false,
    onItemChoose
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [items, setItems] = useState([]);
  const containerRef = useRef(null);
  useEffect(() => {
    if (cards.length) {
      setItems(cards);
    }
  }, [cards]);
  const renderLinks = () => {
    if (items && items.length) {
      return items.map((el, index) => {
        const id = get(el, 'key.targetItem.id');
        const title = get(el, 'title.jss.value');
        const icon = get(el, 'interestIconCode.jss.value');
        const isActive = el.active;
        return /*#__PURE__*/React.createElement(HobbiesAndTravellersTypeItem, {
          key: `${id}_${index}`,
          id: id,
          title: title,
          isActive: isActive,
          icon: icon,
          carouselView: carouselView,
          handleClick: onItemChoose
        });
      });
    }
    return /*#__PURE__*/React.createElement("div", null);
  };
  const RightArrow = /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon",
    width: "31",
    height: "20",
    viewBox: "0 0 31 20"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2660",
    "data-name": "Rectangle 2660",
    width: "31",
    height: "20",
    transform: "translate(31 20) rotate(180)",
    fill: "inherit"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17293",
    "data-name": "Group 17293",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8144",
    "data-name": "Path 8144",
    d: "M28.517,12a3.7,3.7,0,0,0,.491,5.061l4.2,3.662H9V24.03H33.205L29,27.689a3.7,3.7,0,0,0-.484,5.059l11.6-10.374Z",
    transform: "translate(-8.953 -12.253)",
    fill: "inherit"
  })));
  const renderCarousel = () => {
    return /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
      let {
        renderCarousel,
        renderPreviousButton,
        renderNextButton,
        renderDots,
        state
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: `design-wrapper`
      }, /*#__PURE__*/React.createElement("div", {
        className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
      }, renderPreviousButton(() => {}, false, false, RightArrow)), renderCarousel(renderLinks(), {
        responsive: {
          desktop: {
            breakpoint: {
              max: 4000,
              min: 1280
            },
            items: 4,
            slidesToSlide: 1,
            partialVisibilityGutter: 20
          },
          tablet: {
            breakpoint: {
              max: 1280,
              min: 992
            },
            items: 3,
            slidesToSlide: 1,
            partialVisibilityGutter: 20
          },
          mobile: {
            breakpoint: {
              max: 992,
              min: 768
            },
            items: 4
          },
          mobileM: {
            breakpoint: {
              max: 768,
              min: 525
            },
            items: 2
          },
          smallMobile: {
            breakpoint: {
              max: 525,
              min: 0
            },
            items: 1
          }
        },
        containerClass: '',
        partialVisible: true
      })), /*#__PURE__*/React.createElement("div", {
        className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
      }, renderNextButton(() => {}, false, false, RightArrow)));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isCarousel: cards.length > 4
  }, cards.length < 5 ? /*#__PURE__*/React.createElement("div", {
    className: "hobbies-and-travellers-type-wrapper"
  }, renderLinks()) : renderCarousel());
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    isCarousel
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}
    ${isCarousel ? 'carousel-view' : ''}
    `
  }, children);
};
const commonStyles = "c11y25hn";
const ltrStyles = "lyxol6t";
const rtlStyles = "r58amkr";
export default HobbiesAndTravellersTypeCarousel;